import React, { Component } from 'react';
import { getDataFromPartnerAPI } from '../HandleAPICalls/actions';
import { Grid, Image } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import './organization.css';
import ReactFileReader from 'react-file-reader';
import base64 from 'base-64';
import FileParser from './FileParser.jsx';
import { toastr } from 'react-redux-toastr';

export class AddUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeOrganization: "",
			organizationId: "",
			userName: "",
			emailId: "",
			depart:""
		};
	}

	componentDidMount() {
		const activeOrganization = localStorage.getItem('activeOrganization');
		this.setState({ activeOrganization: activeOrganization });
	}

	handleChange = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		if (name === 'orgId') {
			this.setState({ organizationId: value });
		} else if (name === 'userName') {
			this.setState({ userName: value });
		} else if (name === 'emailId') {
			this.setState({ emailId: value });
		}
		else if (name === 'depart') {
			this.setState({ depart: value });
		}
	}

	handleAddUser = () => {
		console.log("username, corporateId, emailId --->>>>>>>>>", this.state.emailId, this.state.organizationId, this.state.userName);
		const organization = localStorage.getItem('activeOrganization');
		const activeId = localStorage.getItem('activeItem');
		let userArray = [{
			"index": 1,
			"employeeId": this.state.organizationId,
			"employeeName": this.state.userName,
			"employeeEmail": this.state.emailId,
			"businessName": this.state.depart?this.state.depart:organization
		}];

		if (this.state.activeOrganization !== "" && this.state.emailId !== "" && this.state.userName !== "" && this.state.organizationId !== "") {
			this.props.getDataFromPartnerAPI(
				`/business-profile/${activeId}`,
				'POST',
				{ 'userInfoList': userArray },
				response => {
					if (response.failures && response.failures.length > 0) {
						response.failures.map((failure) => {
							toastr.error(`Error for ${failure.employeeEmail}`, failure.reason);
						})
					} else {
						this.setState({
							organizationId: "",
							userName: "",
							emailId: "",
							depart:""

						})
						toastr.success('Added New user successfuly');
					}
				},
				err => {
					console.log(err);
				}
			);
		} else {
			toastr.error("Please fill all the fields");
		}
	}

	handleFiles = (files) => {
		// var decodedData = base64.decode(files.base64);
		let jsonBase64 = files.base64;
		let index = jsonBase64.indexOf(',');
		let encodedString = jsonBase64.substr(index + 1);
		let fileName = files.fileList[0].name;
		let formatString = /[^.]*$/.exec(fileName)[0];

		let isCSVFile = formatString.includes('csv');
		let isXLSFile = formatString.includes('xls');
		let isXLSXFile = formatString.includes('xlsx');
		console.log("FILES UPLOADED --->>>>>", jsonBase64);
	}

	goBackAddUser = () => {
		window.location.reload(false);
	}

	render() {
		let bulkUsers = this.props.myOrganization.bulkUsers;
		return (
			<div>
				{ Object.keys(bulkUsers).length > 0 ?
					(
						<Grid padded style={{ marginTop: '0px', padding: '10vh' }}>
							<Helmet>
								<title>Bulk Users Added</title>
							</Helmet>
							<Grid.Row>
								<Grid.Column width={15} textAlign="center">
									<div className="mainUserAdditionFlex">
										<div className="addedContainer">
											<div className="addTextHeading">Users Added = <span>{bulkUsers.usersAdded}</span></div>

											{bulkUsers && bulkUsers.successes.length > 0 ? (
												bulkUsers.successes.map((success) => {
													return (
														<div className="employeeIdBold">{success.employeeId}</div>
													)
												})
											) : (<div>No users Have been added</div>)
											}
										</div>
										{bulkUsers && bulkUsers.failures.length > 0 ? (
											<div className="notAddedContainer">
												<div className="addTextHeading">Below users can not be added because of following reasons</div>
												{ bulkUsers.failures.map((failure) => {
													return (
														<div className="notAddedFlex">
															<div className="employeeIdBold">{failure.employeeId}</div>
															<div className="employeeFailure">{failure.reason}</div>
														</div>
													)
												})}
											</div>
										) : (null)

										}
									</div>
									<div onClick={() => this.goBackAddUser()} className="goBackButtonBulkUser">Go Back</div>
								</Grid.Column>

							</Grid.Row>
						</Grid>
					)
					: (
						<Grid padded style={{ marginTop: '0px', padding: '10vh' }}>
							<Helmet>
								<title>Add new user</title>
							</Helmet>
							<Grid.Row>
								<Grid.Column width={11} textAlign="center">
									<div className='adduserBackContainer' style={{ marginLeft: '200px' }}>
										<a href="/myorganization/active-user">
											<Image
												src="../../assets/arrowLeft.png"
											/>
										</a>
										<h2 style={{ fontWeight: 400, textAlign: 'left', color: '#000', padding: '0.5em', fontSize: '22px', marginTop: '0px' }}>
											Add User
        								</h2>
									</div>
									<div className='userWrapper'>
										<div className='inputWrapperAddUser'>
											<div className='inputLabel'>Organization Id</div>
											<input type='text' placeholder='Enter the Organization Id' name='orgId' value={this.state.organizationId} onChange={(e) => this.handleChange(e)} />
										</div>
										<div className='inputWrapperAddUser'>
											<div className='inputLabel'>Department Name</div>
											<input type='text' placeholder='Enter the Department Name' name='depart' value={this.state.depart} onChange={(e) => this.handleChange(e)} />
										</div>
										<div className='inputWrapperAddUser'>
											<div className='inputLabel'>Name</div>
											<input type='text' placeholder='Enter the name of user' name='userName' value={this.state.userName} onChange={(e) => this.handleChange(e)} />
										</div>
										<div className='inputWrapperAddUser'>
											<div className='inputLabel'>Business Email Id</div>
											<input type='text' placeholder='Enter the Email Id of the user' name='emailId' value={this.state.emailId} onChange={(e) => this.handleChange(e)} />
										</div>
										<div className='addUserButton' onClick={() => this.handleAddUser()}>ADD USER</div>
									</div>
								</Grid.Column>
								<Grid.Column width={4} textAlign="center">
									<div className='bulkUploadContainer'>
										<p>Add users in bulk? <span><a href="../../assets/sampleFile.csv" download>Download format</a></span></p>
										<Image
											src="../../assets/uploadCloud.png"
										/>
										<FileParser />
									</div>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					)
				}
			</div>
		)
	}
}

function mapStateToProps({ myOrganization }) {
	return {
		myOrganization
	};
}

export default withRouter(
	connect(mapStateToProps, {
		getDataFromPartnerAPI,
	})(AddUser)
);


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/addUser.jsx